import React from "react";
import {Card, Container} from "react-bootstrap";
import HeroSection from "../../components/HeroSection.jsx";

function TermsPage() {
    return (
        <Container className="py-4" style={{maxWidth: 900}}>
            <HeroSection
                accent="taxauth"
                eyebrow="Legal"
                title="Terms & Conditions"
                subtitle="Key terms for using BC Tax Certs services."
            />
            <Card className="auth-card p-4">
                <h5>Use of Service</h5>
                <p>BC Tax Certs provides online ordering and delivery of municipal tax certificates. You agree to use the service only for lawful purposes and in accordance with these terms.</p>

                <h5>Accounts</h5>
                <p>You are responsible for maintaining the confidentiality of your account credentials and for all activities under your account. Notify us promptly of any unauthorized use.</p>

                <h5>Data & Privacy</h5>
                <p>We handle customer and tax authority data in accordance with our privacy practices and applicable law. Do not submit sensitive data unless required for the service.</p>

                <h5>Payments & Fees</h5>
                <p>Fees for tax certificate orders and related services are due at the time of purchase. Applicable taxes may be added as required by law.</p>

                <h5>Availability</h5>
                <p>We aim for high availability but do not guarantee uninterrupted access. Maintenance or third-party outages may affect service from time to time.</p>

                <h5>Acceptable Use</h5>
                <p>No probing, scanning, or attempting to bypass security; no misuse of the service to harass, defraud, or infringe on rights of others.</p>

                <h5>Termination</h5>
                <p>We may suspend or terminate access for violation of these terms, suspected misuse, or to protect the service or other users.</p>

                <h5>Changes</h5>
                <p>We may update these terms from time to time. Continued use after changes constitutes acceptance.</p>

                <h5>Contact</h5>
                <p>For questions about these terms, contact support@bctaxcerts.ca.</p>
            </Card>
        </Container>
    );
}

export default TermsPage;
